import { CSSProperties } from 'react'

/** Default width of a page's centered content column, e.g. a settings form. */
export const CONTENT_WIDTH = 720

/** Content column for short content, e.g. a form of a few fields such as the password change. */
export const CONTENT_WIDTH_NARROW = 480

/** Content column for cards and tables, so their actions stay near the content on wide screens. */
export const CONTENT_WIDTH_WIDE = 1080

/** Centered content column; the page header and `PageSaveBar` line up with it. */
export const contentColumnStyle = (width = CONTENT_WIDTH): CSSProperties => ({
  width: '100%',
  maxWidth: width,
  margin: '0 auto'
})

/** Style for wrappers between a `fill` page and the component that fills it, so the height passes through. */
export const fillColumnStyle: CSSProperties = { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }
